module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2018/may-b4a1d1300014d08bce5ba0884e78f3d9.png";